<template>
  <div class="sub-customer">
    <top :username="username"></top>
    <leftMenu></leftMenu>
    <div class="data-govern-body">
      <breadcrumbTrail :trail="'子账户管理'"></breadcrumbTrail>
      <div class="data-search">
        <div class="left">
          <p class="account">
            <span class="account-tip">账户余额(元):</span>
            <span class="account-num">￥{{ account.BalanceAmount }}</span>
          </p>
          <p class="account">
            <span class="account-tip">今日消耗(元):</span>
            <span class="account-num">￥{{ account.TodayConsumeAmount }}</span>
          </p>
          <div class="block">
            <el-button class="search-btn account-btn" type="warning" @click="gotoSubCusBalance" >分配余额</el-button>
          </div>
        </div>
      </div>
      <div class="data-search">
        <div class="left">
          <div class="block">
            <el-autocomplete
              class="input company-name"
              v-model="companyName"
              :fetch-suggestions="queryCompanies"
              placeholder="输入子账户公司名称"
              @select="handleSelect"
            ></el-autocomplete>
          </div>
          <div class="block">
            <el-autocomplete
              class="input subCustom-name"
              v-model="subCustomName"
              :fetch-suggestions="queryNames"
              placeholder="输入子账户姓名"
              @select="handleSelect"
            ></el-autocomplete>
          </div>
          <div class="block">
            <el-autocomplete
              class="input subCustom-email"
              v-model="subCustomEmail"
              :fetch-suggestions="queryEmails"
              placeholder="输入子账户邮箱"
              @select="handleSelect"
            ></el-autocomplete>
          </div>
          <div class="block">
            <el-button class="search-btn" type="warning" >查 询</el-button>
          </div>
        </div>
      </div>
      <div class="data-table">
        <el-table :data="subAccountData" style="width: 100%" :row-class-name="tableRowClassName" >
          <el-table-column prop="CompayName" label="子账户公司名称" width="250"></el-table-column>
          <el-table-column prop="UserName" label="子账户姓名"></el-table-column>
          <el-table-column prop="TelePhone" label="电话号码" width="200"></el-table-column>
          <el-table-column prop="UserEmail" label="子账户邮箱" ></el-table-column>
          <el-table-column prop="AdsBalance" label="账户余额"></el-table-column>
          <el-table-column prop="TodayConsumeAmount" label="当日消耗"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import top from '../public/top.vue'
import leftMenu from '../public/left-menu.vue'
import breadcrumbTrail from '../public/Breadcrumb-Trail.vue'
import qs from 'qs'

export default {
  data () {
    return {
      account: {},
      username: 'xiaoming',
      companies: [],
      names: [],
      emails: [],
      companyName: '',
      subCustomName: '',
      subCustomEmail: '',
      timeout: null,
      subAccountData: [],
      accountParam: {
        userID: 0,
        companyName: '',
        userName: '',
        email: '',
        page: 1
      }
    }
  },
  methods: {
    // 列表各行换色
    tableRowClassName (row) {
      if (row.rowIndex % 2 === 0) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 获取列表数据
    searchSubUserInfo (callback) {
      this.$http.post(this.$root.urlPath.MJK + '/user/SearchSubUserInfo', qs.stringify(this.accountParam)).then(result => {
        const res = result.data
        this.subAccountData = res.data
        // 开启远程请求数据
        this.companies = this.loadCompanyName()
        this.names = this.loadName()
        this.emails = this.loadEmail()
      })
    },
    // 获取账户信息
    getAcountInfo () {
      this.$http.post(this.$root.urlPath.MJK + '/user/GetAcountInfo').then(result => {
        const res = result.data
        console.log(res)
        this.account = {
          userID: res.userID,
          BalanceAmount: res.BalanceAmount,
          TodayConsumeAmount: res.TodayConsumeAmount
        }
        this.accountParam.userID = res.userID
        this.searchSubUserInfo()
      })
    },
    // 获取所有公司名称
    loadCompanyName() {
      let ret = []
      this.subAccountData.forEach((item, i) => {
        let data = {
          value: item.CompayName,
          id: item.CompayName
        }
        ret[i] = data
      })
      return ret
    },
    // 获取所有子账户名称
    loadName() {
      let ret = []
      this.subAccountData.forEach((item, i) => {
        let data = {
          value: item.UserName || '',
          id: item.UserName || ''
        }
        ret[i] = data
      })
      return ret
    },
    // 获取所有邮箱
    loadEmail() {
      let ret = []
      this.subAccountData.forEach((item, i) => {
        let data = {
          value: item.UserEmail,
          id: item.UserEmail
        }
        ret[i] = data
      })
      return ret
    },
    // 远程查询公司
    queryCompanies(queryString, cb) {
      var companies = this.companies
      var results = queryString ? companies.filter(this.createStateFilter(queryString)) : companies

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 1000 * Math.random())
    },
    // 远程查询子账户名称
    queryNames(queryString, cb) {
      var names = this.names
      var results = queryString ? names.filter(this.createStateFilter(queryString)) : names

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 1000 * Math.random())
    },
    // 远程查询邮箱
    queryEmails(queryString, cb) {
      var emails = this.emails
      var results = queryString ? emails.filter(this.createStateFilter(queryString)) : emails

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 1000 * Math.random())
    },
    // 返回远程查询结果
    createStateFilter(queryString) {
      console.log(queryString)
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 选中某一查询结果之后的操作
    handleSelect(item) {
      console.log(item)
    },
    // 跳转到余额分配页面
    gotoSubCusBalance () {
      this.$router.push({
        path: '/subCusBalance'
      })
    }
  },
   mounted() {
    this.getAcountInfo()
  },
  components: {
    top,
    leftMenu,
    breadcrumbTrail
  }
}
</script>

<style lang="scss" scoped>
  @import '../../common/scss/color.scss';

  .data-govern-body {
    padding: 20px 30px 20px 20px;
    position: relative;
    .data-search {
      margin: 20px 0;
      padding: 22px;
      display: flex;
      height: 88px;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      box-sizing: border-box;
      box-shadow: 0 0 3px #e0e0e0;
      .left {
        display: flex;
        justify-content: flex-start;
        .account {
          font-size: 18px;
          line-height: 44px;
          .account-tip {
            // font-family: "MicroSoft YaHei";
            color: #333;
            font-weight: 700;
          }
          .account-num {
            font-family: "Arial";
            color: $mainColor;
          }
          &:first-child {
            margin-right: 47px;
          }
          &:nth-child(2) {
            margin-right: 24px;
          }
        }
        .block {
          margin-right: 23px;
          .company-name {
            width: 232px;
          }
          .subCustom-name {
            width: 147px;
          }
          .subCustom-email {
            width: 165px;
          }
        }
        .search-btn {
          border-radius: 20px;
          width: 94px;
          border: none;
          &:hover {
            background-color: $mainColor;
          }
          &:active {
            background-color: $mainColor;
          }
          &:focus {
            background-color: $mainColor;
          }
          &.account-btn {
            background-color: #44d4ad;
          }
        }
      }
      .right {
        border: 1px solid $mainColor;
        width: 240px;
        text-align: center;
        height: 34px;
        line-height: 34px;
        border-radius: 17px;
        font-size: 14px;
        color: $mainColor;
      }
    }
    .data-table {
      box-shadow: 0 0 3px #e0e0e0;
    }
    .el-pagination {
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      bottom: -80px;
      width: 416px;
      padding-bottom: 40px;
    }
    .el-button--text {
      border: none;
      color: $mainColor;
      span {
        border-bottom: 1px solid $mainColor;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/branch/sub-customer.vue